import {Component} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {VideoWithUrl} from "src/app/model/video-youtube/video-youtube";
import {YoutubeVideoDialogComponent} from "src/app/utils/youtube-video/youtube-video-dialog/youtube-video-dialog.component";
import {ChannelApiService} from "../../api/channel-api.service";
import {Observable} from "rxjs/internal/Observable";
import {YoutubeService} from "../../home/home-youtube/youtube.service";
import {Video} from "../../home/home-youtube/video.model";
import {SuperAdminChannelService} from "./super-admin-channel.service";
import {map} from "rxjs/operators";
import {of} from "rxjs/internal/observable/of";
import {Router} from "@angular/router";
import { MessageService } from "src/app/utils/message/message.service";
import { LanguagePickerService } from "src/app/utils/language-picker/language-picker.service";

@Component({
  selector: 'app-super-admin-channel',
  templateUrl: './super-admin-channel.component.html',
  styleUrls: ['./super-admin-channel.component.scss']
})
export class SuperAdminChannelComponent {

  videos$: Observable<Array<VideoWithUrl>>;
  videos: Array<VideoWithUrl>;

  constructor(
    private channelApi: ChannelApiService,
    private youtube: YoutubeService,
    private saChannelService: SuperAdminChannelService,
    private dialog: MatDialog,
    private router: Router,
    private message: MessageService,
    private languagePickerService: LanguagePickerService,
  ) {
    this.fetch();
  }

  fetch() {
    this.videos$ = this.channelApi.getAll().pipe(
      map(videos => videos.map(video => <VideoWithUrl>{...video, embedUrl: this.youtube.getEmbedUrl(video)}))
    );
    this.videos$.subscribe((videos) => this.videos = videos);
  }

  openNewVideoDialog() {
    const dialogRef = this.dialog.open(YoutubeVideoDialogComponent, {
      width: '250px',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.saveUpdateVideo(result.data);
      }
    });
  }

  saveUpdateVideo(video: Video) {
    this.saChannelService.saveUpdate(video).subscribe((response) => {
      if (response.success) {
        this.message.info("admin.channel.saveSuccess");
        this.fetch();
      } else {
        this.message.error(response.httpError.message);
      }
    });;
  }

  deleteVideo(video: Video) {
    this.saChannelService.delete(video);
    this.videos = this.videos.filter(obj => obj.id !== video.id);
    this.videos$ = of(this.videos);
  }

  goBack(){
    this.router.navigate(['/sa/home'])
  }

  isEnglish(): boolean {
    return this.languagePickerService.getLanguageCode() === 'en';
  }
}
